import { render, staticRenderFns } from "./ContentPreviewAskItems.vue?vue&type=template&id=5d492ffe&scoped=true&"
import script from "./ContentPreviewAskItems.vue?vue&type=script&lang=js&"
export * from "./ContentPreviewAskItems.vue?vue&type=script&lang=js&"
import style0 from "./ContentPreviewAskItems.vue?vue&type=style&index=0&id=5d492ffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d492ffe",
  null
  
)

export default component.exports